import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=b0e93570&scoped=true"
import script from "./JImageUpload.vue?vue&type=script&lang=js"
export * from "./JImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e93570",
  null
  
)

export default component.exports